// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"4":"ec96b8e6","572":"3a0b1c6e"}[chunkId] + ".js";
};